import React, { Component, Fragment }from 'react';
import Radio from 'antd/lib/radio';
import {
  maleDefaultColor,
  femaleDefaultColor,
  unGenderedDefaultColor,
  privateColor,
} from '../../library/constants';
import { getNodeFromNodeObjsWithPrId, urlGet/*, truncateWord*/ } from '../../library/calc';


import Siblings from './siblings';

class Parents extends Siblings {

  unionMarriageHash = {}

  getParentsTR(){

    // console.clear();
    // console.log('getParentsTR');

      this.setState({
        chosenUnionId:  parseInt(this.props.nodeObj.ppu, 10),
      })

      let parentsTr = [];
      if(this.immediateFamilyIsFetched()) {

      const { nodeObjs, /*addNodeFormFocus, */onClickEdit, reloadCanvasTree} = this.props;
      const immediateFam = this.props.nodeObj.immediateFam;
      const { parents, parentPairs } = immediateFam;
      let bracketsNodes = [];
      const bracketColor = 'gray';

      // console.log(`parentPairs: `, JSON.stringify(parentPairs, null, 2));

      if(parents.length > 2 && typeof(parentPairs) !== 'undefined'){
        bracketsNodes.push(parentPairs[0][0]);
        if(parents.length > 3) {
          if( typeof(parentPairs[1]) !== 'undefined' ) bracketsNodes.push(parentPairs[1][0]);
        }
      }

      // console.log(`bracketsNodes: `, JSON.stringify(bracketsNodes, null, 2));


      const canChangeDifferentParent = this.props.canChangeDifferentParent && this.props.canChangeDifferentParent(this.props.nodeObj);
      // console.log(`canChangeDifferentParent: `, canChangeDifferentParent);

      const flipAnchorLinkStyle = this.isFlipPanel ? {
                          'left': `${canChangeDifferentParent ? 86: 50}px`,
                          'width': `${canChangeDifferentParent ? 220: 268}px`,
                        }: {};

      let alreadyShowedRadioButton = [];

      parentsTr = parents.map((parent, idx)=>{

        this.unionMarriageHash[parent.unionId] = parent.marriageId;

        let colorOfGender = parent.g === 'm' ? maleDefaultColor: femaleDefaultColor;
        if(parent.g === 'u'){
          colorOfGender = unGenderedDefaultColor;
        }

        if(typeof(parent.nvp) !== 'undefined'){
          colorOfGender = privateColor;
        }

        let parentFullname = parent.nm;

        if(urlGet('nodeIs') === "prId") parentFullname = `${parent.nm} - ${parent.prId}`;
        if(urlGet('nodeIs') === "n") parentFullname = `${parent.nm} - ${parent.n}`;

        const singleParent = (canChangeDifferentParent && parents.length === 3 && parentPairs[0][0] !== parent.n && parentPairs[0][1] !== parent.n);
        const doubleParentPair = (canChangeDifferentParent && !alreadyShowedRadioButton.includes(bracketsNodes[0]) && parent.n === bracketsNodes[0]) ||
           (canChangeDifferentParent && !alreadyShowedRadioButton.includes(bracketsNodes[1]) && parent.n === bracketsNodes[1]);

        let showRadioButton = false;
        if( singleParent ) showRadioButton = true;
        if( doubleParentPair ) showRadioButton = true;

        alreadyShowedRadioButton.push(parent.n);

        return (


            <tr key={`trParents${idx}`}>
              <td  className='family-list'>
              {

              typeof(this.isFlipPanel) !== 'undefined' && this.isFlipPanel


              ?


                  <span className='radioButtonChoice'
                              style={{
                                position: 'relative',
                                float: 'left',
                                top: (doubleParentPair ? '8px': '0px')
                              }}
                            >

                          {

                            showRadioButton

                            ?

                              <Radio key={`key-${idx}`} value={parent.unionId}></Radio>

                            :


                            <div className='radioButtonChoiceEmpty'
                              style={{
                                'width': `${ canChangeDifferentParent ? 24: 0 }px`,
                              }}
                            ></div>

                          }
                  </span>

              :

              null


              }

                {

                  bracketsNodes.includes(parent.n)

                  ?

              <Fragment>
                  <span
                    className='brackets'
                  >
                    <span style={{
                      position: 'absolute',
                      top: '8px',
                      background: bracketColor,
                      width: '6px',
                      height: '1px',
                    }}>
                    </span>
                    <span style={{
                      position: 'absolute',
                      top: '8px',
                      background: bracketColor,
                      width: '1px',
                      height: '22px',
                    }}>
                    </span>
                    <span style={{
                      position: 'absolute',
                      top: '30px',
                      background: bracketColor,
                      width: '6px',
                      height: '1px',
                    }}>
                    </span>
                  </span>
                </Fragment>
                  :

                  null

                }
                  <div  className={`flip-anchor-row `}
                        style={{
                          'margin-left': `${canChangeDifferentParent ? 8: 0}px`
                        }}
                  >
                    <div className='flip-anchor-bullet' style={{
                      color: `${colorOfGender}`,
                    }}>◉&nbsp;
                    </div>
                    <div  className={`flip-anchor-link `} onClick={()=>{
                          this.onClick(parent);
                        }}
                        style={flipAnchorLinkStyle}
                    >
                      {/*${parent.n} - */}{parentFullname}
                    </div>
                    <div>
                      &nbsp;&nbsp;
                      <span
                          className={ `svgicon`  }
                          style={this.getIconStyle().tree}
                          onClick={()=>{
                            //hidePedigreeAddbox();
                            if( this.props.chartType === 'fan') this.props.refocusFanChart({prId: parent.prId})
                            else reloadCanvasTree(parent.prId);
                            // reloadCanvasTree(parent.prId);
                          }}
                        >&nbsp;</span>
                        <span
                          className={ `svgicon ${( typeof(parent.e) === 'undefined' ? 'hide': '')}`  }
                          style={this.getIconStyle().edit}
                          onClick={()=>{
                            const n = getNodeFromNodeObjsWithPrId({nodeObjs, prId: parent.prId, fromWhere: 'addbox'});
                            onClickEdit(n, parent.prId);
                          }}
                        >&nbsp;
                      </span>
                    </div>
                  </div>
              </td>
            </tr>
        )
      });

    };

    return parentsTr;
  }

  chooseParent(parentChoice){
    const chosenUnionId = parentChoice.target.value;
    const childPrId = this.props.nodeObj.prId
    this.setState({
      chosenUnionId
    })
    this.props.postChosenUnionId({chosenUnionId: this.unionMarriageHash[chosenUnionId], childPrId});
  }

}

export default Parents;

